import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";

// EXTRUDER
import Extruder_page from "./pages/Extruder_page";
import DailyProductionEntry from "./pages/DailyProductionEntry";
import EditPage from "./pages/EditPage";
import ExtruderPrint from "./pages/ExtruderPrint";

// INJECTION
import Injection from "./pages/Injection";
import InjectionAdd from "./pages/InjectionAdd";
import InjectionEdit from "./pages/InjectionEdit";
import InjectionPrint from "./pages/InjectionPrint";

// CRUSH 1
import Crush1_page from "./pages/Crush1_page";
import Crush1Add from "./pages/Crush1Add";
import Crush1Edit from "./pages/Crush1Edit";
import Crush1Print from "./pages/Crush1Print";

// CRUSH 2
import Crush2_page from "./pages/Crush2_page";
import Crush2Add from "./pages/Crush2Add";
import Crush2Edit from "./pages/Crush2Edit";
import Crush2Print from "./pages/Crush2Print";

// RECYCLING
import Recycling_page from "./pages/Recycling_page";
import RecyclingAdd from "./pages/RecyclingAdd";
import RecyclingEdit from "./pages/RecyclingEdit";
import RecyclingPrint from "./pages/RecyclingPrint";

// REPORT
import CrushRecyclingReport from "./pages/CrushRecyclingReport";

// ✅ ITEM MASTER (NEW)
import ItemMasterPage from "./pages/ItemMasterPage";
import ItemMasterAdd from "./pages/ItemMasterAdd";
import ItemMasterEdit from "./pages/ItemMasterEdit";
import ItemMasterView from "./pages/ItemMasterView";

export default function App() {
  return (
    <Routes>
      {/* LOGIN */}
      <Route path="/login" element={<Login />} />

      {/* PRINT ROUTES */}
      <Route
        path="/extruder/print/:id"
        element={
          <ProtectedRoute>
            <ExtruderPrint />
          </ProtectedRoute>
        }
      />
      <Route
        path="/injection/print/:id"
        element={
          <ProtectedRoute>
            <InjectionPrint />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crush-1/print/:id"
        element={
          <ProtectedRoute>
            <Crush1Print />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crush-2/print/:id"
        element={
          <ProtectedRoute>
            <Crush2Print />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recycling/print/:id"
        element={
          <ProtectedRoute>
            <RecyclingPrint />
          </ProtectedRoute>
        }
      />

      {/* MAIN LAYOUT */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />

        {/* EXTRUDER */}
        <Route path="extruder" element={<Extruder_page />} />
        <Route
          path="extruder/add"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <DailyProductionEntry />
            </ProtectedRoute>
          }
        />
        <Route
          path="extruder/edit/:id"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <EditPage />
            </ProtectedRoute>
          }
        />

        {/* INJECTION */}
        <Route path="injection" element={<Injection />} />
        <Route
          path="injection/add"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <InjectionAdd />
            </ProtectedRoute>
          }
        />
        <Route
          path="injection/edit/:id"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <InjectionEdit />
            </ProtectedRoute>
          }
        />

        {/* CRUSH 1 */}
        <Route path="crush-1" element={<Crush1_page />} />
        <Route
          path="crush-1/add"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <Crush1Add />
            </ProtectedRoute>
          }
        />
        <Route
          path="crush-1/edit/:id"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <Crush1Edit />
            </ProtectedRoute>
          }
        />

        {/* CRUSH 2 */}
        <Route path="crush-2" element={<Crush2_page />} />
        <Route
          path="crush-2/add"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <Crush2Add />
            </ProtectedRoute>
          }
        />
        <Route
          path="crush-2/edit/:id"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <Crush2Edit />
            </ProtectedRoute>
          }
        />

        {/* RECYCLING */}
        <Route path="recycling" element={<Recycling_page />} />
        <Route
          path="recycling/add"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <RecyclingAdd />
            </ProtectedRoute>
          }
        />
        <Route
          path="recycling/edit/:id"
          element={
            <ProtectedRoute allowedRoles={["operator", "admin"]}>
              <RecyclingEdit />
            </ProtectedRoute>
          }
        />

        {/* REPORT */}
        <Route
          path="reports/crush-recycling"
          element={<CrushRecyclingReport />}
        />

        {/* ✅ ITEM MASTER ROUTES (NEW) */}
        <Route path="item-master" element={<ItemMasterPage />} />
        <Route
          path="item-master/add"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <ItemMasterAdd />
            </ProtectedRoute>
          }
        />
        <Route path="item-master/view/:id" element={<ItemMasterView />} />
        <Route
          path="item-master/edit/:id"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <ItemMasterEdit />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}